/**
 * BannedPage.jsx
 * صفحه‌ی سراسری «دسترسی مسدود شد» — از هر جای سایت (داشبورد، سفر، چت و ...)
 * که سرور کد BANNED برگرداند، کاربر به این صفحه هدایت می‌شود (نگاه کنید به
 * interceptor پاسخ در src/api/client.js). طراحی هم‌راستا با تم قطار/سفر
 * (journey.css) تا حتی پیام مسدودی هم در فضای داستانی پاترهد بماند.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/journey.css';

function Stars() {
  const stars = React.useMemo(() => Array.from({ length: 80 }, (_, i) => ({
    id: i,
    top: Math.random() * 100,
    left: Math.random() * 100,
    size: Math.random() * 2.5 + 0.5,
    dur: Math.random() * 3 + 2,
    delay: Math.random() * 4,
  })), []);
  return (
    <div className="stars-bg" aria-hidden>
      {stars.map(s => (
        <div key={s.id} className="star" style={{
          top: `${s.top}%`, left: `${s.left}%`,
          width: s.size, height: s.size,
          '--dur': `${s.dur}s`, '--delay': `${s.delay}s`
        }} />
      ))}
    </div>
  );
}

export default function BannedPage() {
  let reason = '';
  try { reason = sessionStorage.getItem('banReason') || ''; } catch (_) {}

  return (
    <div className="journey-root">
      <Stars />
      <div style={{
        position: 'relative', zIndex: 1, minHeight: '100vh',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '2rem 1.25rem'
      }}>
        <div style={{
          maxWidth: 480, width: '100%', textAlign: 'center',
          background: 'rgba(10,10,15,0.55)', border: '1px solid rgba(201,168,76,0.35)',
          borderRadius: 16, padding: '2.5rem 1.75rem', backdropFilter: 'blur(6px)',
          boxShadow: '0 0 60px rgba(201,168,76,0.08)'
        }}>
          <div style={{ fontSize: '3.5rem', marginBottom: '0.75rem', filter: 'grayscale(0.2)' }}>🕯️🔒</div>

          <h1 className="welcome-title cinzel" style={{ fontSize: '1.6rem', marginBottom: '0.5rem' }}>
            دروازه‌های هاگوارتز بسته شد
          </h1>

          <p style={{ color: 'var(--gold-light)', fontSize: '0.95rem', marginBottom: '1.25rem' }}>
            دسترسی شما به پاترهد توسط مدیران مسدود شده است.
          </p>

          {reason ? (
            <div style={{
              background: 'rgba(116,0,1,0.15)', border: '1px solid rgba(201,168,76,0.25)',
              borderRadius: 10, padding: '0.9rem 1rem', marginBottom: '1.5rem',
              color: 'var(--text)', fontSize: '0.9rem', lineHeight: 1.8, textAlign: 'right'
            }}>
              <strong style={{ color: 'var(--gold)' }}>دلیل مسدودی: </strong>{reason}
            </div>
          ) : (
            <p style={{ color: 'var(--muted)', lineHeight: 1.8, marginBottom: '1.5rem', fontSize: '0.9rem' }}>
              انگار طلسمی جادویی راه شما را بسته… اما نگران نباش، این پایان داستان نیست.
            </p>
          )}

          <p style={{ color: 'var(--muted)', lineHeight: 1.9, fontSize: '0.85rem', marginBottom: '1.75rem' }}>
            اگر فکر می‌کنی این مسدودی اشتباه بوده یا می‌خواهی درباره‌اش توضیح بدهی،
            می‌توانی مستقیم با پشتیبانی پاترهد در تماس باشی.
          </p>

          <Link
            to="/contact"
            style={{
              display: 'inline-block', padding: '0.65rem 1.75rem', borderRadius: 999,
              background: 'linear-gradient(to right, #4a1a8a, var(--gold))',
              color: '#0a0a0f', fontWeight: 700, textDecoration: 'none', fontSize: '0.9rem'
            }}
          >
            ارتباط با پشتیبانی
          </Link>

          <div style={{ marginTop: '1.5rem' }}>
            <Link to="/" style={{ color: 'var(--muted)', fontSize: '0.8rem', textDecoration: 'underline' }}>
              بازگشت به صفحه اصلی
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
